import "./form-subscription.scss";
import { useFormContext } from "react-hook-form";
import { SubscriptionFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import { useFilterSubscriptionContext } from "../filter-subscription/filter-subscription.context";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useQyGetAllMember } from "@factory/query/member.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { useCallback } from "react";
import { useQyGetService } from "@factory/query/service.query";

type InputFormSchema = SubscriptionFormSchema;
export function FormSubscription() {
  const { control, setValue } = useFormContext<SubscriptionFormSchema>();
  const { getFilterEntityValues } = useFilterSubscriptionContext();
  const { member, service } = getFilterEntityValues();

  const { data: member_ } = useQyGetAllMember("", 99999);
  const memberData = member_?.data || [];
  const options = LabelValue.MapArray(
    memberData,
    (label) => label.first_name + " " + label.last_name || "-",
    (value) => value.code
  );

  const memberDropdownElement = useCallback(() => {
    if (member) {
      setValue("member", member);
      return null;
    }

    return (
      <DropdownControl<InputFormSchema>
        control={control}
        name="member"
        label="member Name"
        className="w-full md:w-3/4"
        options={options}
      />
    );
  }, [member, options]);

  const { data: service_ } = useQyGetService("", 99999);
  const serviceData = service_?.data || [];
  const serviceOptions = LabelValue.MapArray(
    serviceData,
    (label) => label.name || "-",
    (value) => value.code
  );

  const serviceDropdownElement = useCallback(() => {
    if (service) {
      setValue("service", service);
      return null;
    }

    return (
      <DropdownControl<InputFormSchema>
        control={control}
        name="service"
        label="Service Name"
        className="w-full md:w-3/4"
        options={serviceOptions}
      />
    );
  }, [service, serviceOptions]);

  return (
    <div id="FormSubscription" className="subscription">
      {memberDropdownElement()}
      {serviceDropdownElement()}
      <InputControl<InputFormSchema>
        control={control}
        name="startDate"
        label="Start Date"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter startDate"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="endDate"
        label="End Date"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter endDate"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isSubscription"
        label="Is Subscription"
        containerClassName="pb-2"
      />
    </div>
  );
}

export default FormSubscription;
